(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("connectionsList", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/connections/connectionsListView.html",
            controller: ["connectionsResource", "$state", ConnectionsListCtrl],
            controllerAs: "vm"
        };
        function ConnectionsListCtrl(connectionsResource, $state) {
            var vm = this;
            connectionsResource.getConnectionsListViewModel(function (data) {
                vm.model = data;
            });
            vm.configure = function (systemName) {
                $state.go("main.settings.connectionForm" + systemName);
            };
        }
    });
}());
